import { OrderSource } from "../order";

/**
 * Add an item to the cart
*/
export interface CartItemAddDto {
    cartId: string;
    productId: string;
    variantId?: string;
    quantity: number;
    attributes?: { [key: string]: string | number; };
    userEmail?: string;
    userId?: string;
}

/**
 * Update an item in the cart
 */
export interface CartItemUpdateDto {
    cartId: string;
    itemId: string;
    quantity: number;
}

/**
 * Remove an item from the cart
 */
export interface CartItemRemoveDto {
    cartId: string;
    itemId: string;
}

export interface CartUpdateDto {
    cartId: string;
    source: OrderSource;
    accountDomainId?: string;
    customer: {
        email: string;
    };
    delivery: {
        type: 'SHIPPING' | 'PICKUP';
        pickupBranchId?: string;
        firstname: string;
        lastname: string;
        phone: {
            countryCode: string;
            national: string;
            international: string;
            type: string;
            validated: boolean;
        };
        address: {
            country: string;
            department: string;
            locality: string;
            street: string;
            complement?: string;
            notes?: string;
            postalCode: string;
            mapPosition: {
                lat: number;
                lng: number;
            };
        };
    };
    billing: {
        name: string;
        address: string;
        city: string;
        department: string;
    };
    accountPaymentMethodId?: string;
    customerNote?: string | null;
}

/**
 * Confirm a cart
 */
export interface CartConfirmDto {
    cartId: string;
}

/**
 * Validation information for a cart item
 */
export interface CartItemValidation {
    hasIssues: boolean;              // Indica si hay problemas con este item
    issues: string[];                // Lista de problemas encontrados (mensajes legibles)
    errorCode?: CartItemErrorCode;   // Código específico del error principal
    currentPrice?: number;           // Precio actual del producto (si cambió)
    availableStock?: number;         // Stock disponible actual
    isProductActive?: boolean;       // Si el producto está activo
}

/**
 * Error codes for cart items
 */
export enum CartItemErrorCode {
    PRICE_INCREASED = 'PRICE_INCREASED',           // Precio aumentó
    PRICE_DECREASED = 'PRICE_DECREASED',           // Precio disminuyó  
    PRODUCT_INACTIVE = 'PRODUCT_INACTIVE',         // Producto ya no está disponible
    STOCK_INSUFFICIENT = 'STOCK_INSUFFICIENT',     // Stock insuficiente (hay algo disponible)
    STOCK_UNAVAILABLE = 'STOCK_UNAVAILABLE',       // Sin stock (0 disponible)
    VALIDATION_ERROR = 'VALIDATION_ERROR'          // Error general de validación
}
